import { WrappedButton, WrappedButtonType } from 'common/src/code/ui/button';
import InlineMessage from 'common/src/code/ui/panel/InlineMessage.component';
import Session from 'common/src/code/utils/Session';
import React from 'react';
import { useBankConnection } from './hooks/useBankConnection';

export const NsaSurchargesMessage = ({ onClose }) => {
	const { isConnecting, handleConnectBank, renderAddPaymentMethod } =
		useBankConnection(onClose);

	const { nsaSurchargePercentage } = Session.getDynamicSettings();

	return (
		<>
			<InlineMessage
				type="information"
				header={`A ${nsaSurchargePercentage}% fee applies when adding funds to your balance, including auto-funding, using a credit card.`}
				text="Avoid this fee by updating your Account Funds payment method below to a bank account. If you don't have a bank account connected, you can add one by clicking Connect bank account."
				canClose={true}
				actions={
					<WrappedButton
						label={isConnecting ? 'Connecting...' : 'Connect bank account'}
						buttonType={WrappedButtonType.TertiaryWhite}
						dataqa="connect-bank-account-message-add-button"
						onClick={handleConnectBank}
						disabled={isConnecting}
					/>
				}
				dataqa="surcharge-info-banner"
				onClose={onClose}
			/>

			{/* Hidden AddPaymentMethod - uses modal logic without showing modal */}
			{renderAddPaymentMethod()}
		</>
	);
};
